import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { REFETCH_POST_MALONE_SAVED_TEMPLATES_MUTATION } from './refetchPostMaloneSavedTemplates.mutation';
import {
  RefetchPostMaloneSavedTemplatesMutation,
  RefetchPostMaloneSavedTemplatesMutationVariables
} from './__generated__/RefetchPostMaloneSavedTemplatesMutation';

export const useRefetchPostMaloneSavedTemplates = () => {
  return useMutation<RefetchPostMaloneSavedTemplatesMutation, RefetchPostMaloneSavedTemplatesMutationVariables>(
    REFETCH_POST_MALONE_SAVED_TEMPLATES_MUTATION,
    { client: kmsClient }
  );
};
